import { Extensions } from '@tiptap/core'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import StarterKit from '@tiptap/starter-kit'
import { Indent } from './Indent'
import { OrderedListType } from './OrderedListType'

/**
 * The editor schema, deliberately kept in step with the buttons in `MenuBar`.
 *
 * Anything the schema accepts but the toolbar cannot produce is a trap for the author: it can
 * arrive by paste and then never be removed again. A pasted Word heading was the case of #6465 —
 * `<h2>` renders bold and large, the bold button only nests a `<strong>` inside something that is
 * already bold, and no button turns it back into body text. So every node kept here has a button,
 * and everything else is switched off. Text inside a switched-off block is never lost: ProseMirror
 * treats a tag with no parse rule as a block boundary, so the words land in a paragraph of their own.
 *
 * Exported separately from the component so the schema tests build from the same list the editor uses.
 */
export const rtfExtensions: Extensions = [
   StarterKit.configure({
      heading: false,
      blockquote: false,
      code: false,
      codeBlock: false,
      horizontalRule: false,
      strike: false,
   }),
   Underline,
   Link,
   OrderedListType,
   Indent,
]
